import script from "./AllChatUser.vue?vue&type=script&setup=true&lang=js"
export * from "./AllChatUser.vue?vue&type=script&setup=true&lang=js"

import "./AllChatUser.vue?vue&type=style&index=0&id=f5133e76&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5133e76"]])

export default __exports__